import { Component } from '@angular/core';

@Component({
  selector: 'app-license',
  templateUrl: './license.component.html',
  styleUrl: './license.component.css'
})
export class LicenseComponent {

}
